import React from "react";
import { NavLink } from "react-router-dom";
import Certifications from "../components/aboutme/Certifications";
import Details from "../components/aboutme/Details";
import Education from "../components/aboutme/Education";
import SkillCard from "../components/aboutme/SkillCard";
import { SubHeading } from "../components/aboutme/style";
import { Container, SecondaryText } from "../styles/global";

const About = () => {
  return (
    <Container className="about-wrapper">
      <img src="assest/images/sectionHeaders/aboutus.png" alt="aboutus" />

      <div className="mt-10">
        <SecondaryText>
          I’m a full-stack developer and data enthusiast, currently advancing my
          expertise with a Master’s in Data Science at Northeastern University.
          With over two years of experience as a Software Development Engineer
          💻, I am now on a journey to learn and build innovative, AI-driven
          solutions that combine software development and data science for
          powerful solutions.
        </SecondaryText>
        <SecondaryText className="mt-2">
          <span>
            If you'd like to connect or just say hi, don't hesitate to reach
            out!
            <NavLink to="/Contact" className="ml-2 text-[#ff5757]">
              (click here to drop message)
            </NavLink>
          </span>
        </SecondaryText>
      </div>

      <div className="mt-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-4 ">
          <div id="skill">
            <SubHeading className="text-center mb-10">SKILLS</SubHeading>
            <SkillCard />
          </div>
          <div id="details">
            <SubHeading className="text-center mb-10">Details</SubHeading>
            <Details />
          </div>
        </div>
      </div>

      <div className="mt-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div id="certifications">
            <SubHeading className="text-center mt-10 mb-10">
              Certification
            </SubHeading>
            <Certifications />
          </div>
          <div id="education">
            <SubHeading className="text-center mt-10 mb-10">
              Education
            </SubHeading>
            <div className="pl-8">
              <Education />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default About;
